require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-engaging-social-media-videos.json") })
        }
      }, "path---tapd-in-engaging-social-media-videos");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-engaging-social-media-videos!./.cache/json/tapd-in-engaging-social-media-videos.json
// module id = 829
// module chunks = 231608221292675